import { useState, useCallback } from 'react';

/**
 * Manages the employee assignment workflow for shifts
 *
 * Handles the state transitions and operations for:
 * - Toggling the employee selection interface
 * - Assigning selected employees to shifts
 * - Removing employee assignments
 * - Closing selection mode without assigning
 *
 * @param {Function} handleShiftUpdate - Updates shift data in the store
 * @returns {Object} Assignment state and handlers
 */
export const useEmployeeAssignment = (handleShiftUpdate) => {
  const [isSelectingEmployee, setIsSelectingEmployee] = useState(false);

  const handleStartEmployeeSelection = useCallback(() => {
    setIsSelectingEmployee(true);
  }, []);

  const handleUnassignButtonClick = useCallback(() => {
    handleShiftUpdate({
      conflicts: null,
      assignedName: null,
      eid: null,
      assignedProfileImageUrl: null,
    });
  }, [handleShiftUpdate]);

  const handleEmployeeSelect = useCallback(
    (employee, conflicts) => {
      handleShiftUpdate({
        conflicts: conflicts || [],
        assignedName: employee.displayName,
        eid: employee.id,
        assignedProfileImageUrl: employee.profileImageUrl,
      });
      setIsSelectingEmployee(false);
    },
    [handleShiftUpdate]
  );

  const handleCancelEmployeeSelection = useCallback(() => {
    setIsSelectingEmployee(false);
  }, []);

  return {
    isSelectingEmployee,
    handleStartEmployeeSelection,
    handleUnassignButtonClick,
    handleEmployeeSelect,
    handleCancelEmployeeSelection,
  };
};
